export const CITIES_LIST = "CITIES_LIST";
export const CITIES_CREATE = "CITIES_CREATE";
export const CITIES_UPDATE = "CITIES_UPDATE";
export const CITIES_DELETE = "CITIES_DELETE";
export const CITIES_SHOW = "CITIES_SHOW";
export const CITIES_PUBLIC_LIST = "CITIES_PUBLIC_LIST";
